import React from 'react';
import useSpotConfig from '@host-panel/request/config/use-config';
import SecondaryNavigation from '../../common/navigation/secondary-navigation';
import EmbeddedReport from '../embedded-report/EmbeddedReport';

type Props = {
  spotId: string;
  page: string;
};

const ANALYTICS_REPORT_URL_KEY = 'tenant.host_panel.communityReportUrl';

const AnalyticsNext = ({ page, spotId }: Props) => {
  const [[analyticsReportUrl]] = useSpotConfig([ANALYTICS_REPORT_URL_KEY], {
    [ANALYTICS_REPORT_URL_KEY]: ''
  });
  const menuItems = [
    { label: 'Overview', routeName: 'analytics-next', navParams: { spot_id: spotId } }
  ];

  return (
    <div>
      <SecondaryNavigation title="Analytics" selected={page} menuItems={menuItems} />
      {analyticsReportUrl && (
        <EmbeddedReport
          url={analyticsReportUrl as string}
          trackEventName="analytics beta page viewed"
        />
      )}
    </div>
  );
};

export default AnalyticsNext;
